import Vue from 'vue';
import Vuex from 'vuex';
import modules from './modules'; // axiosの初期化

import axios from 'axios';
var axiosParams = {
  baseURL: '/api'
};
var api = axios.create(axiosParams);
api.interceptors.request.use(function (config) {
  config.url = config.url + '.json';
  return config;
});
Vue.use(Vuex);
var store = new Vuex.Store({
  modules: modules,
  strict: false,
  state: function state() {
    return {
      api: api
    };
  }
});
window.$store = store;
export default store;